// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2AM2i","ranges":"BmiRanges_ranges__2RWUj"};